module.exports = __webpack_public_path__ + "img/close-modal.efbf0222.svg";